class SystemPermission {
    constructor(data) {
        this.id = data["id"]
        this.module = data["module"]
        this.name = data["name"]
        this.description = data["description"]
        this.user_has_perm = data["user_has_perm"]
        this.active_user_can_grant_perm = data["active_user_can_grant_perm"]
    }
}

export default SystemPermission